"use client"

import React, { useEffect, useMemo, useRef, useState } from 'react'

type Props = {
  html: string
  css?: string
  js?: string
  className?: string
  minHeight?: number
}

export default function ArticleSandbox({ html, css = '', js = '', className = '', minHeight = 600 }: Props) {
  const iframeRef = useRef<HTMLIFrameElement | null>(null)
  const [height, setHeight] = useState<number>(minHeight)

  const srcDoc = useMemo(() => {
    const safeCss = css || ''
    const body = html || ''
    const rawJs = js || ''
    // JSON.stringify para inyectar el código sin romper el HTML y poder capturar SyntaxError
    const jsJson = JSON.stringify(rawJs)
    return `<!doctype html><html><head><meta charset=\"utf-8\"/><meta name=\"viewport\" content=\"width=device-width, initial-scale=1\"/>
<style>html,body{margin:0;padding:0;background:#fff;} body{font-family:Montserrat,system-ui,-apple-system,Segoe UI,Roboto,sans-serif; padding:16px; background:#fff;}
img{max-width:100%;height:auto} .container{max-width:100%;}
${safeCss}</style>
</head><body>
<div class=\"container\">${body}</div>
<script>(function(){
  function sendHeight(){ try{ var h = document.body.scrollHeight; parent.postMessage({ __letArticleHeight: h }, '*'); }catch(e){} }
  window.addEventListener('load', sendHeight); window.addEventListener('resize', sendHeight); setInterval(sendHeight, 300);
  // Ejecutar JS de artículo de forma segura y catcheable
  try {
    var __code = ${jsJson};
    if (__code && typeof __code === 'string') { (new Function(__code))(); }
  } catch (e) { try { console.error('Article JS error:', e); } catch(_){} }
})();</script>
</body></html>`
  }, [html, css, js])

  useEffect(() => {
    const onMsg = (ev: MessageEvent) => {
      const d: any = ev.data
      if (d && typeof d === 'object' && '__letArticleHeight' in d) {
        const h = Math.max(Number(d.__letArticleHeight) || minHeight, 200)
        setHeight(h)
      }
    }
    window.addEventListener('message', onMsg)
    return () => window.removeEventListener('message', onMsg)
  }, [minHeight])

  return (
    <iframe
      ref={iframeRef}
      sandbox="allow-scripts"
      className={className}
      style={{ width: '100%', border: 'none', borderRadius: 0, minHeight: 200, height, background: 'transparent', overflow: 'hidden' }}
      srcDoc={srcDoc}
      aria-label="Article content"
      scrolling="no"
    />
  )
}
